import { useAuth0 } from "@auth0/auth0-react";

export function useAppointmentsAPI() {
  const { getAccessTokenSilently } = useAuth0();

  const fetchWithAuth = async (url, options = {}) => {
    const accessToken = await getAccessTokenSilently();
    const headers = new Headers(options.headers || {});
    headers.append("Authorization", `Bearer ${accessToken}`);
    return fetch(url, { ...options, headers });
  };

  const getOpenAppointmentDatesForServiceAndDate = async (serviceUuid, date) => {
    const url = `${process.env.REACT_APP_BACK_API}/appointments?serviceUuid=${encodeURIComponent(
        serviceUuid
    )}&date=${encodeURIComponent(date)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json(); // [{ startAt: ISO, endAt: ISO }]
  };

  const getMyAppointments = async () => {
    const url = `${process.env.REACT_APP_BACK_API}/appointments/mine`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  const checkoutAppointment = async (selections, notes) => {
    // selection must include: selectedServiceUuid, selectedStaffUuid, selectedStartAt (ISO), notes, optional animalUuid
    const payload = { appointmentDtos: selections, notes: notes };
    const res = await fetchWithAuth(`${process.env.REACT_APP_BACK_API}/appointments/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    // Expect a JSON body containing at least { uuid: ... }
    const contentType = res.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      return res.json();
    }
    // Fallback: if backend returns plain text UUID, wrap it
    return  await res.text();
  };

  const getUpcomingAppointments = async (limit = 10) => {
    const url = `${process.env.REACT_APP_BACK_API}/dashboard/upcoming-appointments?limit=${encodeURIComponent(
      limit
    )}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  return { getOpenAppointmentDatesForServiceAndDate, getMyAppointments, checkoutAppointment, getUpcomingAppointments };
}
